import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-website',
  templateUrl: './header-website.component.html',
  styleUrls: ['./header-website.component.scss']
})
export class HeaderWebsiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
